import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewInsumo_Uso = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'insumo_uso',
        name: 'Insumo Uso',
        component: ViewInsumo_Uso,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
